export default [
  {
    name: "Learning and Development",
    icon: "model_training",
    to: "/training",
    enabled: true,
  },
];
